/*
    @file:
        fullpage.js

    @description:
        Core Javascript file that handles
        home page section scrolling
*/

// Variables
var $                   = require( 'jquery' );
var jQuery              = require( 'jquery' );

var slick               = require('slick-carousel');

// Events
$(document).ready(function () {
    $('.section-projects .carousel').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        dots: false,
        nextArrow: $('.section-projects .content .btn-carousel-right'),

        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    variableWidth: false,
                    dots: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    dots: false,
                    arrows: true,
                    infinite: true,
                }
            },
        ]
    });

    $('.page-section-projects .carousel').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        dots: false,
        nextArrow: $('.page-section-projects .content .btn-carousel-right'),

        responsive: [
            {
              breakpoint: 9999,
              settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  variableWidth: false,
                  dots: false,
              }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    dots: false,
                    arrows: true,
                    infinite: true,
                }
            },
        ]
    });

    function resizeDivs() {
        if($('.section-projects').length > 0) {
            var maxHeight = 0;

            $(".section-projects .carousel-item .text").each(function(){
                if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
            });

            $('.section-projects .carousel-item .text').each(function() {
                $(this).height(maxHeight);
            });
        }

        if($('.page-section-projects').length > 0) {
            var maxHeight = 0;

            $(".page-section-projects .carousel-item .text").each(function(){
                if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
            });

            $('.page-section-projects .carousel-item .text').each(function() {
                $(this).height(maxHeight);
            });
        }
    }

    setTimeout(function() {
        resizeDivs();
    }, 1000);

    $(window).resize(function() {
        resizeDivs();
    });

    $('.page-section-interesting .carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        dots: false,
        nextArrow: $('.page-section-interesting .content .btn-carousel-right'),
    });

    $('.section-aim .section-bottom .carousel').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        dots: false,
        arrows: true,
        nextArrow: $('.section-aim .section-bottom .btn-carousel-right'),
    });

    $('.multimedia-block .multimedia-block-carousel-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,

        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                }
            },
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    });

    $('.section-knowledge .text-wrapper').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,

        responsive: [
            {
                breakpoint: 9999,
                settings: 'unslick'
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true,
                    dots: false,
                }
            }
        ]
    });

    $('.content-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<span>0' + (+i+1) +'</span>';
        },
    });


    $('.about-project').each(function() {
        $(this).find('.carousel-main .carousel-text').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: $(this).find('.carousel-main .carousel-nav'),
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                },
            ]
        });
        $(this).find('.carousel-main .carousel-nav').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            cssEase: true,
            asNavFor: $(this).find('.carousel-main .carousel-text'),
            focusOnSelect: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    });

    $('.about-project-book').each(function() {
        $(this).find('.carousel-main .carousel-text').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: $(this).find('.carousel-main .carousel-nav'),
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                },
            ]
        });
        $(this).find('.carousel-main .carousel-nav').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: $(this).find('.carousel-main .carousel-text'),
            focusOnSelect: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    });

    $('.why-book .content-wrapper').slick({
        arrows: false,

        responsive: [
            {
                breakpoint: 9999,
                settings: 'unslick'
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }
        ]
    });
});